module.exports = __webpack_public_path__ + "static/img/设计师6.d94b1e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/设计师6.png
// module id = qsBl
// module chunks = 1